import type { CompleteRegistrationPayloadDto } from '../dto';
import type { CompleteRegistrationPayload } from '../models';

export function mapCompleteRegistrationPayloadToDto(
  payload: CompleteRegistrationPayload,
): CompleteRegistrationPayloadDto {
  return {
    code: payload.code,
    first_name: payload.firstName,
    last_name: payload.lastName,
    password: payload.password,
    password_confirmation: payload.passwordConfirmation,
  };
}
